<mat-toolbar class="mat-elevation-z8 main-header" [class.hide]="hideHeader">
  <div class="menu">
    <button class="btn-menu" mat-icon-button *ngIf="sidenav.mode === 'over'" (click)="sidenav.toggle()">
      <mat-icon *ngIf="!sidenav.opened" class="toggle-sidenav"> menu </mat-icon>
      <mat-icon *ngIf="sidenav.opened" class="toggle-sidenav"> close </mat-icon>
    </button>
  </div>
  <div class="img_position">
    <img class="imgSet" routerLink="/dashboard" src="assets/img/ruralxLogo.png"/>
  </div>
  <span class="xxxx-menu-spacer"></span>
  <div></div>
  <span class="toolbar-item-spacer"></span>
  <ul class="icon-list">
    <span class="cart-invisible">

      <li (click)="cartFun()">
        <div class="cart-container shopping-cart">
          <mat-icon class="shopping-cart" [attr.id]="isDesktop ? 'cartIconTarget' : ''">shopping_cart</mat-icon>
          <span class="cart-badge">{{itemQuantity}}</span>
        </div>
        <span class="icon-menu-cart">Cart</span>
        <span class="icon-menu-cart">Items</span>
      </li>
    </span>
<li class="lang-align">
<div class="lang-box" (click)="toggleLanguage()">
        <mat-icon class="lanuage-icon">language</mat-icon>
    <span class="selected-lang" *ngIf="showUsername">
        {{ selectedLanguage === 'hi' ? 'Hindi' : 'English' }}
    </span>
    <span class="lang-label">
        Language
    </span>
</div>

</li>
    <li (click)="openDialogD()">
      <mat-icon class="shopping-map">location_on</mat-icon>
      <span class="icon-menu">Check</span>
      <span class="icon-menu"><strong>Availability</strong></span>
    </li>


    <!-- <li (click)="isGuest ? goToLogin() : userMenuTrigger.openMenu()">
      <mat-icon id="signMake" mat-icon-button matTooltip="" class="shopping-user">account_circle</mat-icon>
      <span class="icon-menu">Hello</span>
       <span class="icon-menu"><strong>{{(username)|titlecase }}</strong></span> 
    </li> -->
    <li (click)="isGuest && goToLogin()" mat-icon-button [matMenuTriggerFor]="!isGuest ? userAccountMenu : null">
      <mat-icon id="signMake" mat-icon-button matTooltip="" class="shopping-user">account_circle</mat-icon>
      <span class="icon-menu">Hello</span>
      <span class="icon-menu">
        <strong *ngIf="showUsername">{{ (username) | titlecase }}</strong>
      </span>
    </li>

    <mat-menu #userAccountMenu [overlapTrigger]="false" yPosition="below">
      <button mat-menu-item routerLink="/my-account"><mat-icon>person</mat-icon><span>My Account</span></button>
      <button mat-menu-item routerLink="/setting"><mat-icon>settings</mat-icon><span>Settings</span></button>
      <button mat-menu-item routerLink="#"><mat-icon>help</mat-icon><span>Help</span></button>
      <button mat-menu-item (click)="userLogout()"><mat-icon>exit_to_app</mat-icon>Logout</button>
    </mat-menu>

  </ul>
</mat-toolbar>

<!-- Toolbar -->


<mat-sidenav-container>
  <mat-sidenav #sidenav="matSidenav" class="mat-elevation-z8 sidebar-container">
    <div class="container">
      <ng-template #showIcon>
        <div class="avatar_name">
          <mat-icon>person</mat-icon>
        </div>
      </ng-template>
      <div class="avatar_name" *ngIf="username && showUsername; else showIcon">{{ username[0].toUpperCase()}}</div>
    </div>
    <h4 class="name" *ngIf="showUsername">Welcome, {{ (username) | titlecase }}</h4>

    <mat-accordion multi="false">


      <!-- Dashboard -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>dashboard</mat-icon>
            <span class="ml-2">Dashboard</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item routerLink="dashboard" routerLinkActive="active-link" (click)="sidenav.toggle()">
            <mat-icon matListIcon>dashboard</mat-icon><span class="ml-2">Home</span>
          </a>
        </mat-action-list>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>grid_view</mat-icon>
            <span class="ml-2">Category</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
          <a mat-list-item routerLink="category" routerLinkActive="active-link" (click)="sidenav.toggle()">
            <mat-icon matListIcon>grid_view</mat-icon> <span class="ml-2">Category</span>
          </a>
        </mat-action-list>
      </mat-expansion-panel>
      <div class="info-list">
        <div class="info-item">
          <mat-icon matListIcon>description</mat-icon>
          <span class="text" (click)="openTermsAndConditionDialog();sidenav.toggle()">Terms & Condition</span>
          <mat-icon matListIcon>chevron_right</mat-icon>
        </div>

        <div class="info-item">
          <mat-icon matListIcon>lock</mat-icon>
          <span class="text" (click)="openPrivacyPolicyDialog();sidenav.toggle()">Privacy Policy</span>
          <mat-icon matListIcon>chevron_right</mat-icon>
        </div>

        <div class="info-item">
          <mat-icon matListIcon>language</mat-icon>
          <span class="text" (click)="ruralxRedirection();sidenav.toggle()">Go to Website</span>
          <mat-icon matListIcon>chevron_right</mat-icon>
        </div>

        <div class="info-item">
          <mat-icon matListIcon>email</mat-icon>
          <span class="text" (click)="contactEmail();sidenav.toggle()">Support : info@ruralx.in</span>
          <mat-icon matListIcon>chevron_right</mat-icon>
        </div>
        
        <!-- <div class="info-item">
          <mat-icon matListIcon>language</mat-icon>
          <span class="text" (click)="testVoice()">Test Voice</span>
          <mat-icon matListIcon>chevron_right</mat-icon>
        </div> -->

      </div>
      <div class="drawer-version" *ngIf="currentVersion!==''">
        App Version <span>{{currentVersion}}</span>
      </div>
    </mat-accordion>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-header class="header"></app-header>
    <div class="main-content pt-5" #scrollContainer (scroll)="onContentScroll($event)">
      <router-outlet></router-outlet>
    </div>
    <app-footer class="footer" [sidenav]="sidenav"></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>